import { fromJS } from 'immutable';
import { CRM_VIEW_REPORT_CONTEXT } from 'reporting-data/createReportConfig';
import { getSuperStoreValue } from 'crm-index-ui/rewrite/superstore/getSuperStoreValue';
import { setSuperStoreValue } from 'crm-index-ui/rewrite/superstore/setSuperStoreValue';
const reportLocalStorageKey = 'CRM:report:mostRecentlyUsed';
const getReportLocalStorageKey = (objectTypeId, viewId) => {
  return `${reportLocalStorageKey}:${objectTypeId}:${viewId}`;
};
export const getMostRecentlyUsedReport = async (objectTypeId, viewId, viewName) => {
  try {
    const storageKey = getReportLocalStorageKey(objectTypeId, viewId);
    const report = await getSuperStoreValue(storageKey);
    return report ? fromJS(JSON.parse(report)).set('name', viewName).set('reportContext', CRM_VIEW_REPORT_CONTEXT) : undefined;
  } catch (e) {
    return Promise.resolve();
  }
};
export const setMostRecentlyUsedReport = (report, objectTypeId, viewId) => {
  try {
    const reportString = JSON.stringify(report.filter((_, key) => ['config', 'chartType', 'displayParams', 'name', 'reportContext'].includes(key)));
    const reportStorageKey = getReportLocalStorageKey(objectTypeId, viewId);
    void setSuperStoreValue(reportStorageKey, reportString);
  } catch (e) {
    // This error is safe to ignore
  }
};